import React, { useState } from "react";
import Navbar from "./Navbar";
import { supabase } from "./supabase";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetSent, setResetSent] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    setError("");
    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: form.email,
      password: form.password,
    });
    setLoading(false);
    if (signInError) {
      setError(signInError.message);
    } else {
      window.location.href = "/dashboard";
    }
  };

  const handleReset = async () => {
    if (!resetEmail) {
      setError("Please enter your email address.");
      return;
    }
    setResetLoading(true);
    setError("");
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(resetEmail, {
      redirectTo: "https://forgesa-ee8b98.netlify.app/reset-password",
    });
    setResetLoading(false);
    if (resetError) {
      setError(resetError.message);
    } else {
      setResetSent(true);
    }
  };

  const inputStyle = {
    width: "100%",
    background: "#F5F0E8",
    border: "1.5px solid #EDE8DF",
    borderRadius: 8,
    padding: "11px 14px",
    color: "#1A1A2E",
    fontSize: 16,
    fontFamily: "var(--font-body)",
    outline: "none",
    marginBottom: 14,
    boxSizing: "border-box",
  };

  const labelStyle = {
    fontSize: 11,
    color: "#888",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginBottom: 6,
    display: "block",
  };

  return (
    <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh", color: "#1A1A2E" }}>

      <style>{`
        .login-wrap { max-width: 440px; margin: 0 auto; padding: 56px 24px; }
        .login-card { background: #fff; border: 1px solid #EDE8DF; border-radius: 20px; padding: 32px; }
        @media (max-width: 480px) {
          .login-wrap { padding: 32px 16px; }
          .login-card { padding: 24px 20px; border-radius: 16px; }
        }
      `}</style>

      <Navbar />

      <div className="login-wrap">

        {!showReset ? (
          <>
            {/* HEADER */}
            <div style={{ textAlign: "center", marginBottom: 32 }}>
              <div style={{ width: 56, height: 56, background: "#1B3A6B", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <h1 style={{ fontSize: 26, fontWeight: 900, color: "#1A1A2E", margin: "0 0 6px", letterSpacing: "-0.02em" }}>
                Welcome <span style={{ color: "#1B3A6B" }}>Back</span>
              </h1>
              <p style={{ color: "#888", fontSize: 13 }}>Sign in to your Forge SA account</p>
            </div>

            {/* FORM */}
            <div className="login-card">
              <label style={labelStyle}>Email Address</label>
              <input
                type="email"
                placeholder="ayanda@email.com"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                style={inputStyle}
              />

              <label style={labelStyle}>Password</label>
              <input
                type="password"
                placeholder="Your password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                style={{ ...inputStyle, marginBottom: 8 }}
              />

              <div style={{ textAlign: "right", marginBottom: 20 }}>
                <span
                  onClick={() => { setShowReset(true); setError(""); }}
                  style={{ fontSize: 12, color: "#1B3A6B", cursor: "pointer", fontWeight: 600 }}
                >
                  Forgot password?
                </span>
              </div>

              {error && (
                <div style={{ background: "rgba(192,57,43,0.07)", border: "1px solid rgba(192,57,43,0.2)", borderRadius: 8, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: "#C0392B" }}>
                  {error}
                </div>
              )}

              <button
                onClick={handleLogin}
                disabled={loading}
                style={{ width: "100%", background: loading ? "#EDE8DF" : "#1B3A6B", border: "none", borderRadius: 99, padding: "14px", color: loading ? "#888" : "#fff", fontWeight: 800, fontSize: 15, cursor: loading ? "not-allowed" : "pointer", fontFamily: "var(--font-body)", marginBottom: 16 }}
              >
                {loading ? "Signing in..." : "Sign In"}
              </button>

              <div style={{ textAlign: "center", fontSize: 13, color: "#888" }}>
                Don't have an account?{" "}
                <span
                  onClick={() => window.location.href = "/register"}
                  style={{ color: "#1B3A6B", fontWeight: 600, cursor: "pointer" }}
                >
                  Join the Movement
                </span>
              </div>
            </div>
          </>
        ) : (
          <>
            {resetSent ? (
              <>
                {/* RESET SENT */}
                <div style={{ textAlign: "center", marginBottom: 32 }}>
                  <div style={{ width: 56, height: 56, background: "#F5F0E8", border: "1px solid #EDE8DF", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                    </svg>
                  </div>
                  <h1 style={{ fontSize: 24, fontWeight: 900, color: "#1A1A2E", margin: "0 0 6px", letterSpacing: "-0.02em" }}>
                    Check Your <span style={{ color: "#1B3A6B" }}>Email</span>
                  </h1>
                  <p style={{ color: "#888", fontSize: 13 }}>
                    We sent a reset link to{" "}
                    <strong style={{ color: "#1B3A6B" }}>{resetEmail}</strong>
                  </p>
                </div>
                <div className="login-card" style={{ textAlign: "center" }}>
                  <button
                    onClick={() => { setShowReset(false); setResetSent(false); setResetEmail(""); }}
                    style={{ background: "transparent", border: "1.5px solid #EDE8DF", borderRadius: 99, padding: "12px 28px", color: "#888", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "var(--font-body)" }}
                  >
                    Back to Sign In
                  </button>
                </div>
              </>
            ) : (
              <>
                {/* RESET FORM */}
                <div style={{ textAlign: "center", marginBottom: 32 }}>
                  <div style={{ width: 56, height: 56, background: "#F5F0E8", border: "1px solid #EDE8DF", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
                    </svg>
                  </div>
                  <h1 style={{ fontSize: 26, fontWeight: 900, color: "#1A1A2E", margin: "0 0 6px", letterSpacing: "-0.02em" }}>
                    Reset <span style={{ color: "#1B3A6B" }}>Password</span>
                  </h1>
                  <p style={{ color: "#888", fontSize: 13 }}>Enter your email and we'll send you a reset link.</p>
                </div>

                <div className="login-card">
                  <label style={labelStyle}>Email Address</label>
                  <input
                    type="email"
                    placeholder="ayanda@email.com"
                    value={resetEmail}
                    onChange={(e) => setResetEmail(e.target.value)}
                    style={inputStyle}
                  />

                  {error && (
                    <div style={{ background: "rgba(192,57,43,0.07)", border: "1px solid rgba(192,57,43,0.2)", borderRadius: 8, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: "#C0392B" }}>
                      {error}
                    </div>
                  )}

                  <button
                    onClick={handleReset}
                    disabled={resetLoading}
                    style={{ width: "100%", background: resetLoading ? "#EDE8DF" : "#1B3A6B", border: "none", borderRadius: 99, padding: "14px", color: resetLoading ? "#888" : "#fff", fontWeight: 800, fontSize: 15, cursor: resetLoading ? "not-allowed" : "pointer", fontFamily: "var(--font-body)", marginBottom: 10 }}
                  >
                    {resetLoading ? "Sending..." : "Send Reset Link"}
                  </button>

                  <button
                    onClick={() => { setShowReset(false); setError(""); }}
                    style={{ width: "100%", background: "transparent", border: "1.5px solid #EDE8DF", borderRadius: 99, padding: "12px", color: "#888", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "var(--font-body)" }}
                  >
                    Back to Sign In
                  </button>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}